/** Quién administra el espacio: ve Clara, audiencias, integraciones y configuración. */
export function canAdminister(role: string | null | undefined): boolean {
  return role === "owner" || role === "admin";
}
